import { useCallback, useMemo } from 'react'
import { Form, Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { TimelineHolidaysAndLeave } from '../../../../common/icons'
import CustomSwitch from '../../../../common/Switch'
import CustomAutocompleteField from '../../../../common/AutoCompleteField'
import styles from './AnnualLeave.module.css'
import { useGetVacationYears } from '../../../../api/endpoints/organization-data-rest-controller/organization-data-rest-controller'

export const AnnualLeave = ({ settings, onSettingChange, isSaving }) => {
  const { t } = useTranslation()

  const { data: vacationYears, error } = useGetVacationYears()

  const vacationYearsOptions = useMemo(() => 
  vacationYears?.map((option) => ({
    value: option.id,
    yearLabel: option.annualVacationYear,
    label: `${t('CalculationYearBooking')} [${option.annualVacationYear}]`,
  })) || [],
  [vacationYears, t]
)

  const getCalculationYearValue = useCallback(() => {
    if (!settings?.calculationYearOption) {
      return null
    }
    const selectedYear = vacationYears?.find((y) => y.annualVacationYear === settings.calculationYearOption)
    return selectedYear
      ? {
          value: selectedYear.id,
          yearLabel: selectedYear.annualVacationYear,
          label: `${t('CalculationYearBooking')} [${selectedYear.annualVacationYear}]`,
        }
      : null
  }, [settings, vacationYears, t])

  return (
    <div>
      <div className={styles.sectionHeader}>
        <div className={styles.iconContainer}>
          <TimelineHolidaysAndLeave />
        </div>
        <label className={styles.sectionTitle}>{t('AnnualLeave')}</label>
      </div>

      {error && (
        <Alert variant="danger" className="mb-3">
          <Alert.Heading>{t('Error', 'Virhe')}</Alert.Heading>
          <p>{t('VacationYearsLoadError', 'Laskentavuosien lataaminen epäonnistui. Yritä uudelleen.')}</p>
        </Alert>
      )}
      
      <Form>
        <Form.Group className="mb-3">
          <div className={styles.switchGroup}>
            <CustomSwitch
              id="saturdaysCalculatedAsHoliday"
              label={t('SaturdaysIncluded')}
              checked={settings?.saturdaysCalculatedAsHoliday ?? true}
              onChange={(e) => onSettingChange('saturdaysCalculatedAsHoliday', e.target.checked)}
              disabled={isSaving}
              fixedWidth
              labelPosition="left"
            />
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <div className={styles.switchGroup}>
            <CustomSwitch
              id="leaveBookingBalanceLimitOnly"
              label={t('LeaveBookingBalanceLimitOnly')}
              checked={settings?.leaveBookingBalanceLimitOnly || false}
              onChange={(e) => onSettingChange('leaveBookingBalanceLimitOnly', e.target.checked)}
              disabled={isSaving}
              fixedWidth
              labelPosition="left"
            />
          </div>
          <label className={styles.helperText} style={{ maxWidth: '300px'}}>
            {t('VacationRules')}
          </label>
        </Form.Group>

        <Form.Group className="mb-3">
          <CustomAutocompleteField
            label={t('CalculationYearOption')}
            placeholder={`${t('CalculationYearBooking')} [${t('CalculationYearBookingCode')}]`}
            value={getCalculationYearValue()}
            onChange={(opt) => onSettingChange('calculationYearOption', opt?.yearLabel || null)}
            options={vacationYearsOptions}
            disabled={isSaving}
            width="42%"
          />
        </Form.Group>
      </Form>
    </div>
  )
}
